/** Receiver measurements only; these events cannot change the room's layout. */
export const TV_CAMERA_DEMAND = 'tv:camera-demand';
export const TV_CAMERA_BUDGET_READ = 'tv:camera-budget:read';
export const TV_CAMERA_DEMAND_TTL_MS = 25_000;
export const TV_CAMERA_TIERS = ['media-small', 'small', 'media-medium', 'pip', 'grid'] as const;
export type TvCameraTier = typeof TV_CAMERA_TIERS[number];
export interface TvCameraDemand { sessionId: string; tier: TvCameraTier }
export interface TvCameraDemandReport { roomId: string; demands: TvCameraDemand[] }
export interface TvCameraBudget extends TvCameraDemandReport { fallbackTier: TvCameraTier }

export function isTvCameraTier(value: unknown): value is TvCameraTier {
  return typeof value === 'string' && (TV_CAMERA_TIERS as readonly string[]).includes(value);
}
export function isTvCameraDemandReport(value: unknown): value is TvCameraDemandReport {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const report = value as TvCameraDemandReport;
  if (Object.keys(report).some(key => key !== 'roomId' && key !== 'demands')
    || typeof report.roomId !== 'string' || !report.roomId.length || report.roomId.length > 100
    || !Array.isArray(report.demands) || report.demands.length > 32) return false;
  const ids = new Set<string>();
  return report.demands.every(demand => {
    if (!demand || typeof demand !== 'object' || Array.isArray(demand)
      || Object.keys(demand).some(key => key !== 'sessionId' && key !== 'tier')
      || typeof demand.sessionId !== 'string' || !demand.sessionId.length || demand.sessionId.length > 128
      || ids.has(demand.sessionId) || !isTvCameraTier(demand.tier)) return false;
    ids.add(demand.sessionId);
    return true;
  });
}
